import { CustomTranslateModule } from '@flowaccount/landing'

import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { FunctionsRoutingModule } from './functions-routing.module'
import { CoreModule } from '../../core.module'

import { QuotationComponent } from './quotation/quotation.component'
import { QuotationDocumentComponent } from './quotation/quotation-document/quotation-document.component'
import { QuotationBenefitComponent } from './quotation/quotation-benefit/quotation-benefit.component'
import { QuotationVideoComponent } from './quotation/quotation-video/quotation-video.component'
import { QuotationFormComponent } from './quotation/quotation-form/quotation-form.component'
import { QuotationJoinComponent } from './quotation/quotation-join/quotation-join.component'

import { ReceiptComponent } from './receipt/receipt.component'
import { ReceiptDocumentComponent } from './receipt/receipt-document/receipt-document.component'
import { ReceiptBenefitComponent } from './receipt/receipt-benefit/receipt-benefit.component'
import { ReceiptFormComponent } from './receipt/receipt-form/receipt-form.component'
import { ReceiptVideoComponent } from './receipt/receipt-video/receipt-video.component'
import { ReceiptJoinComponent } from './receipt/receipt-join/receipt-join.component'
import { ReceiptMobileAppComponent } from './receipt/receipt-mobile-app/receipt-mobile-app.component'
import { BillingNoteInvoiceComponent } from './billing-note-invoice/billing-note-invoice.component'
import { BillingForWholesalersSectionComponent } from './billing-note-invoice/billing-for-wholesalers-section/billing-for-wholesalers-section.component'
import { BillingFormComponent } from './billing-note-invoice/billing-form/billing-form.component'
import { BillingVideoComponent } from './billing-note-invoice/billing-video/billing-video.component'
import { BillingJoinComponent } from './billing-note-invoice/billing-join/billing-join.component'
import { BillingBenefitComponent } from './billing-note-invoice/billing-benefit/billing-benefit.component'
import { TaxInvoiceComponent } from './tax-invoice/tax-invoice.component'
import { TaxInvoiceIntroComponent } from './tax-invoice/tax-invoice-intro/tax-invoice-intro.component'
import { TaxInvoiceBenefitComponent } from './tax-invoice/tax-invoice-benefit/tax-invoice-benefit.component'
import { TaxInvoiceFormComponent } from './tax-invoice/tax-invoice-form/tax-invoice-form.component'
import { TaxInvoiceJoinComponent } from './tax-invoice/tax-invoice-join/tax-invoice-join.component'
import { TaxInvoiceVideoComponent } from './tax-invoice/tax-invoice-video/tax-invoice-video.component'
import { ShopeeLazadaComponent } from './shopee-lazada/shopee-lazada.component'
import { ShopeeLazadaIntroComponent } from './shopee-lazada/shopee-lazada-intro/shopee-lazada-intro.component'
import { ShopeeLazadaBenefitComponent } from './shopee-lazada/shopee-lazada-benefit/shopee-lazada-benefit.component'
import { ShopeeLazadaVideoComponent } from './shopee-lazada/shopee-lazada-video/shopee-lazada-video.component'
import { ShopeeLazadaVideoOnlineComponent } from './shopee-lazada/shopee-lazada-video-online/shopee-lazada-video-online.component'
import { MobilePosComponent } from './mobile-pos/mobile-pos.component'
import { MobilePosIntroComponent } from './mobile-pos/mobile-pos-intro/mobile-pos-intro.component'
import { MobilePosCashierComponent } from './mobile-pos/mobile-pos-cashier/mobile-pos-cashier.component'
import { MobilePosSunmiComponent } from './mobile-pos/mobile-pos-sunmi/mobile-pos-sunmi.component'
import { MobilePosAppComponent } from './mobile-pos/mobile-pos-app/mobile-pos-app.component'
import { FlowpayComponent } from './flowpay/flowpay.component'
import { FlowpayIntroComponent } from './flowpay/flowpay-intro/flowpay-intro.component'
import { FlowpayGoodPointComponent } from './flowpay/flowpay-good-point/flowpay-good-point.component'
import { FlowpayQrPaymentComponent } from './flowpay/flowpay-qr-payment/flowpay-qr-payment.component'
import { FlowpayThirdPartyPaymentComponent } from './flowpay/flowpay-third-party-payment/flowpay-third-party-payment.component'
import { FlowpayVideoComponent } from './flowpay/flowpay-video/flowpay-video.component'
import { MultiShopBannerComponent } from './shopee-lazada/multi-shop-banner/multi-shop-banner.component'
import { TaxCalculationComponent } from './tax-calculation/tax-calculation.component'
import { ReactiveFormsModule } from '@angular/forms'
import { MobilePosVideoComponent } from './mobile-pos/mobile-pos-video/mobile-pos-video.component'
import { MobilePosThermalPrintersComponent } from './mobile-pos/mobile-pos-thermal-printers/mobile-pos-thermal-printers.component'
import { FunctionsForBusinessComponent } from './functions-for-business/functions-for-business.component'
import { FunctionsForBusinessIntroComponent } from './functions-for-business/functions-for-business-intro/functions-for-business-intro.component'
import { FunctionsForBusinessFeatureComponent } from './functions-for-business/functions-for-business-feature/functions-for-business-feature.component'
import { FunctionsForAccountingComponent } from './functions-for-accounting/functions-for-accounting.component'
import { FunctionsForAccountingIntroComponent } from './functions-for-accounting/functions-for-accounting-intro/functions-for-accounting-intro.component'
import { FunctionsForAccountingFeatureComponent } from './functions-for-accounting/functions-for-accounting-feature/functions-for-accounting-feature.component'

@NgModule({
  declarations: [
    QuotationComponent,
    QuotationDocumentComponent,
    QuotationBenefitComponent,
    QuotationVideoComponent,
    QuotationFormComponent,
    QuotationJoinComponent,
    ReceiptComponent,
    ReceiptDocumentComponent,
    ReceiptBenefitComponent,
    ReceiptMobileAppComponent,
    ReceiptFormComponent,
    ReceiptVideoComponent,
    ReceiptJoinComponent,
    BillingNoteInvoiceComponent,
    BillingForWholesalersSectionComponent,
    BillingFormComponent,
    BillingVideoComponent,
    BillingJoinComponent,
    BillingBenefitComponent,
    TaxInvoiceComponent,
    TaxInvoiceIntroComponent,
    TaxInvoiceBenefitComponent,
    TaxInvoiceFormComponent,
    TaxInvoiceJoinComponent,
    TaxInvoiceVideoComponent,
    ShopeeLazadaComponent,
    ShopeeLazadaIntroComponent,
    ShopeeLazadaBenefitComponent,
    ShopeeLazadaVideoComponent,
    ShopeeLazadaVideoOnlineComponent,
    MobilePosComponent,
    MobilePosIntroComponent,
    MobilePosCashierComponent,
    MobilePosSunmiComponent,
    MobilePosAppComponent,
    FlowpayComponent,
    FlowpayIntroComponent,
    FlowpayGoodPointComponent,
    FlowpayQrPaymentComponent,
    FlowpayThirdPartyPaymentComponent,
    FlowpayVideoComponent,
    MultiShopBannerComponent,
    TaxCalculationComponent,
    MobilePosVideoComponent,
    MobilePosThermalPrintersComponent,
    FunctionsForBusinessComponent,
    FunctionsForBusinessIntroComponent,
    FunctionsForBusinessFeatureComponent,
    FunctionsForAccountingComponent,
    FunctionsForAccountingIntroComponent,
    FunctionsForAccountingFeatureComponent,
  ],
  imports: [
    CommonModule,
    CoreModule.forRoot(),
    FunctionsRoutingModule,
    ReactiveFormsModule,
    CustomTranslateModule.forChild({ path: 'functions' }),
  ],
})
export class FunctionsModule {}
